import { getActiveBrandConfig, getActivePrestationBrandConfig } from "../../config/environment.config";

/** Liste des brouillons v2 : `/{marque}/tableau-de-bord/{prestation}/brouillons`. */
export const draftsPath = (): string => `/${getActiveBrandConfig()}/tableau-de-bord/${getActivePrestationBrandConfig()}/brouillons`;

/** Page de modification d'un brouillon : `/{marque}/tableau-de-bord/{prestation}/brouillons/{id}`. */
export const draftEditPath = (id: number | string): string => `${draftsPath()}/${id}`;

/** Onglet « Brouillons » de l'ancien écran « Mes cours » (composant 3). */
export const legacyDraftsPath = (): string => `/${getActiveBrandConfig()}/tableau-de-bord/${getActivePrestationBrandConfig()}`;
